export const tabs = [
  new Array(5).fill(' '),
  new Array(4).fill(' '),
  new Array(3).fill(' '),
];
